import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AuthentificationService} from './authentification.service';
import {TransactionsService} from './transactions.service';
import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';
import {AppComponent} from './app.component';
import {StocksService} from './stocks.service';
import {FileDownloadService} from './file-download.service';

import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'enter-stock',
    templateUrl: './templates/enter-stock.component.html',
    styleUrls: ['./styles/enter-stock.component.css'],
    providers: [TransactionsService, AuthentificationService, SortTable, StocksService, FileDownloadService],
    encapsulation: ViewEncapsulation.None
})
export class EnterStockComponent implements OnInit {
    session_mode: string = "RECEPTION";
    id_purchase_order: number = 0;
    bcf_details: any;
    bcf_name: string;
    bcf_receipt_list: any;
    validate_bt: boolean = true;
    disabled_input: boolean = true;
    bfc_validate: any = [];
    complete_infos: boolean = false;
    articles_list_popup: Array<any> = [];
    article_selected_list: Array<string> = [];
    motif: string = "";
    selectedValue: string = "BRET";
    global_remark: string = "";
    remains_to_deliver: Array<any> = [];
    docket_date: any = new Date();
    number_reference: any = "";
    enter_name: string = "";

    actions = [
        {value: 'BRET', viewValue: 'Retourner'},
        {value: 'BREC_BRESL', viewValue: 'Receptionner et livrer reste'},
        {value: 'BREC_M', viewValue: 'Receptionner et annuler reste'}
    ];

    constructor(private app_component: AppComponent,
        private filedownloadservice: FileDownloadService,
        private transactions_service: TransactionsService,
        private router: Router,
        private authentification_service: AuthentificationService,
        private sort_table: SortTable,
        private stock_service: StocksService,
        private datepipe: DatePipe) {
        this.CheckUSerSession();
        this.app_component.valTest = '/enter-bcf';
        this.app_component.GetParent();
    }

    Exists(id_article: string, selected: Array<string>): boolean {
        //console.log();
        return selected.indexOf(id_article) > -1;

    }

    Toggle(pannier: any, selected: Array<string>): void {

        var index = selected.indexOf(pannier.id_article);
        if (index > -1) {
            selected.splice(index, 1);
        }
        else {
            selected.push(pannier.id_article);
        }

        console.log(this.article_selected_list);
        this.EditArticleSessionPurchaseDetail(pannier);
        //this.quantity = selected.length;
    };

    CheckUSerSession(): void {
        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }

    GetSentPurchaseOrder() {
        this.transactions_service.GetSentPurchaseOrder().then(result => {this.bcf_receipt_list = result['list']; this.bfc_validate = result['list']; this.sort_table.SetDataArray(result['list'], [{value: "name", type: ""}, {value: "supplier", type: ""}, {value: "date", type: ""}, {value: "user", type: ""}]);});
    }

    SortValidate(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.bfc_validate = this.sort_table.GetSortData();
        // recupérer  data
    }

    OrderDetails(bcf: any): void {
        this.notconforme = false;
        this.id_purchase_order = bcf.id_purchase_order;
        this.bcf_name = bcf.name;

        //this.invalid_from = false;
        this.transactions_service.GetPurchaseOrderDetails(bcf.id_purchase_order).then(result => {
            this.bcf_details = result['list'];
            this.motif = result['motif'];
            this.number_reference = parseInt(result['last_number_reference']) + 1;
            this.enter_name = result['name'];
            this.docket_date = new Date();
            if (result['list'].length !== 0) {
                this.validate_bt = false;
                this.UpdateCheckedList();
            }
        });
    }

    UpdateCheckedList(): void {
        this.article_selected_list = [];
        for (let i = 0; i < this.bcf_details.length; i++) {
            if (this.bcf_details[i]['conforme'] === "yes") {
                this.article_selected_list.push(this.bcf_details[i]['id_article']);
                //this.Exists(this.bcf_details[i]['id_article'],this.article_selected_list);
            }
        }
        console.log(this.article_selected_list);
    }

    ValidateBcf(): void {
        this.transactions_service.ValidateBcf(this.id_purchase_order, this.bcf_name, this.datepipe.transform(this.docket_date, 'medium'))
            .then(result => {
                this.bcf_details = result['list'];
                this.bcf_receipt_list = result['sent'];
                this.validate_bt = true;
                this.bcf_name = "";
                this.notconforme = false;
                this.bfc_validate = result['sent'];
                this.sort_table.SetDataArray(
                    result['sent'], [
                        {value: "name", type: ""},
                        {value: "supplier", type: ""},
                        {value: "date", type: ""},
                        {value: "user", type: ""}
                    ]);
                this.complete_infos = false;
                this.app_component.hide_wrapper(false);
            });
    }

    AddArticleInfos(): void {
        if (!this.notconforme) {
            this.selectedValue = "";
        }
        this.transactions_service.AddArticleInfos(this.global_remark, this.id_purchase_order, this.selectedValue).then(result => {
            this.SessionModPopup(result['issued']);
            this.TotalArticle(result['issued'], result['remains_to_deliver']);
            this.articles_list_popup = result['issued'];
            this.remains_to_deliver = result['remains_to_deliver'];
            this.bfc_validate = result['list'];
            if (result['issued'].length > 0 || result['remains_to_deliver'].length > 0) {
                this.complete_infos = true;
                this.app_component.hide_wrapper(true);
            }
            if (result['issued'].length === 0 && result['remains_to_deliver'].length === 0) {
                this.bcf_details = [];
            }
        });
    }

    total_art_top: number = 0;
    total_art_bottom: number = 0;
    TotalArticle(list1: any, list2: any): void {
        this.total_art_top = 0;
        this.total_art_bottom = 0;
        for (let i = 0; i < list1.length; i++) {
            this.total_art_top = this.total_art_top + parseInt(list1[i]['qte_received']);
        }
        for (let i = 0; i < list2.length; i++) {
            this.total_art_top = this.total_art_top + parseInt(list2[i]['qte_received']);
        }
    }

    EditArticleSessionPurchaseDetail(pannier: any): void {
        let checked = this.article_selected_list.join('_');
        this.transactions_service.EditArticleSessionPurchaseDetailBcf(pannier.id_article, checked).then(result => {
            this.bcf_details = result['list'];
            this.disabled_input = false; this.SessionMod(result['list']);
            this.IsConforme(result['list']);
            this.UpdateCheckedList();
        });
    }

    notconforme: boolean = false;
    IsConforme(list: any): void {
        this.notconforme = false;
        this.selectedValue = "";
        for (let i = 0; i < list.length; i++) {
            if (list[i]['conforme'] === "no") {
                this.notconforme = true;
                this.selectedValue = "BRET";
                break;
            }

        }
    }

    LoadSessionPurchase() {
        this.transactions_service.GetSentPurchaseOrderDetails().then(session_list => {this.bcf_details = session_list['list']; if (session_list['list'].length !== 0) {this.validate_bt = false} });
    }

    EditAndValidateModification(prod: any): void {

        if (prod.status === "RECEPTION") {
            console.log(prod.status);
            //console.log(prod.id_article);
            this.EditArticleSessionPurchaseDetail(prod);
        } else if (prod.status === 'MODIFICATION') {
            console.log(prod.status);
            this.ValidateEditArticleSessionPurchaseDetail(prod);
        }

    }

    SessionMod(list: any): void {
        this.session_mode = "RECEPTION";
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === "MODIFICATION") {
                this.session_mode = "MODIFICATION";
            }
        }
        //  console.log(this.session_mode);
    }

    session_mode_pop_up: string = "KO";
    SessionModPopup(list: any): void {
        this.session_mode_pop_up = "OK";
        for (let i = 0; i < list.length; i++) {
            if (list[i].serial_status === "KO") {
                this.session_mode_pop_up = "KO";
            }
        }


        //  console.log(this.session_mode);
    }

    ValidateEditArticleSessionPurchaseDetail(prod: any): void {
        console.log(prod);
        if (isNaN(prod.qte_received)) {
            prod.qte_received = "Valeur invalide";
            setTimeout(() => {this.LoadSessionPurchase()}, 3500);
        }
        else {
            this.transactions_service.ValidateEditArticleSessionPurchaseDetailBcf(prod).then(result => {
                this.bcf_details = result['list'];
                this.SessionMod(result['list']);
                this.IsConforme(result['list']);
                this.UpdateCheckedList();
            });
        }
        //this.transactions_service.ValidateEditArticleSessionPurchase(prod).then(result => {this.pannier_list = result['list']; this.SessionMod(result['list'])});
    }

    Cancel(): void {

        this.complete_infos = false;
        this.app_component.hide_wrapper(false);
    }

    IsAvalableSerialNumber(article: any): void {
        console.log(article.serial);
        //this.ValidateForm();
        this.stock_service.IsAvalableSerialNumber(article).then(result => {this.articles_list_popup = result['list']; console.log(result['result']);});
    }

    ValidateForm(): void {
        var indices = [];
        var index = this.articles_list_popup.findIndex(article => article['serial'] === "Entrez le n° de série");

        /* console.log(index);
         console.log(indices);*/
    }

    ValidatePop(): void {
        this.ValidateBcf();
    }

    EditAndValidateModificationPopup(prod: any): void {
        //console.log(this.src_bt);

        //if (this.src_bt === "../../img/ico_modif.png") {prod.status === "RECEIPTION"
        if (prod.status === "RECEPTION") {
            //console.log(prod.id_article);
            this.EditArticleSessionPopup(prod);
        } else if (prod.status === 'MODIFICATION') {
            this.ValidateEditArticleSessionPopup(prod);
        }
    }

    EditArticleSessionPopup(prod: any): void {
        this.stock_service.EditArticleSessionReceiptBcf(prod.index).then(result => {this.articles_list_popup = result['list']; this.SessionModPopup(result['list'])});
    }

    ValidateEditArticleSessionPopup(prod: any): void {
        this.stock_service.ValidateEditArticleSessionReceiptPopup(prod).then(result => {this.articles_list_popup = result['list']; this.SessionModPopup(result['list'])});
    }

    CancelArticleInfos() {
        this.stock_service.CancelEnterStock().then(result => {
            this.validate_bt = true;
            this.bcf_details = result['list'];
            this.motif = result['motif'];
            this.number_reference = undefined;
            this.docket_date = undefined;
            this.enter_name = "";
            this.notconforme = false;
        });
    }

    DownloadPdf(): void {

        this.filedownloadservice.EnterDocket(this.number_reference, this.datepipe.transform(this.docket_date, 'dd-MM-yyyy'), this.enter_name);
    }

    selected_tr: number = -1;
    Selected(value: number): void {
        this.selected_tr = value;
    }

    Color(index: number) {
        //        console.log(index);
        //        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {

                'background-color': '#B3B6B7', //'#FFB400',
                //'color': 'orange',
            };
        }

        return styles;
    }


    ColorIndex(index: number) {
        //        console.log(index);
        //        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {

                //'background-color': '#B3B6B7', //'#FFB400',
                'color': 'white',
            };
        }

        return styles;
    }

    ngOnInit() {
        this.GetSentPurchaseOrder();
    }

}



// WEBPACK FOOTER //
// ./src/app/enter-stock.component.ts